define(function (require) {
	const tpl = require('../templates/t_lov_mfa_success.hbs');
	const ViewManager = require('civicsUtils/view_manager');
	const factorUtils = require('civicsViews/core/two_factor_authentication/2fa_utility');

	return Marionette.LayoutView.extend({
		className: 'v-lov-mfa-success-modal',
		template: tpl,
		ui: {
			closeButton: '.bbm-btn-close',
			continueButton: '.continue-success-modal'
		},
		events: {
			'click @ui.closeButton': 'closeModal',
			'click @ui.continueButton': 'continueClicked'
		},
		initialize: function (options) {
			this.options = options;
			this.config = options.config?.config || options.config || {};
			this.modalRegion = options.modalRegion;
			this.activeProcess = options.activeProcess;
			this.wizardProject = options.wizardProject;
			this.globalConfig = ViewManager.globalConfig().toJSON();
			this.loginChannel = this.config?.loginChannel || null;
		},
		onShow: function () {
			// Don't remove session storage immediately - let user interact with modal first
		},
		continueClicked: function(e) {
			if (e) {
				e.stopPropagation();
				e.preventDefault();
			}
			this.closeModal();
		},
		closeModal: function(e) {
			if (e) {
				e.stopPropagation();
				e.preventDefault();
			}
			
			if (App.localStorage.get('CIVICS')) {
				App.localStorage.remove('CIVICS', 'REQUIRES_MFA_ENROLLMENT');
			}
			
			if (this.loginChannel) {
				// Close this modal first, then call go:checkStatus after it's fully closed
				if (this.modalRegion) {
					this.modalRegion.hideModal(function() {
						this.loginChannel.command('go:checkStatus');
					}.bind(this));
				} else {
					this.loginChannel.command('go:checkStatus');
				}
			} else {
				if (this.config?.loginRedirectPage || this.activeProcess || this.wizardProject) {
					if (this.activeProcess || this.wizardProject) { // If there's an active process or a wizard project, it means it's coming from an Invite or saving a Wizard Project it shouldn't take the user to a redirect page.
						window.location.reload();
					} else {
						window.location.href = this.config.loginRedirectPage;
					}
				} else {
					window.location.reload();
				}
			}
		},
		templateHelpers: function () {
			let methodType = factorUtils().getAuthenticationStrings();
			const mfaCount = App.user?.mfaSubscriptions?.length || 0;
			const bodyText = mfaCount == 1 ? 
				i18n.t('CIVICS.LOGIN_FALLBACK.MFA_FIRST_METHOD_SUCCESS_MSG', {methodTypeBody: methodType.methodTypeBody}) :
				i18n.t('CIVICS.LOGIN.ENFORCED_MFA.SUCCESS_MESSAGE', {methodTypeBody: methodType.methodTypeBody});
			return {
				title: i18n.t('CIVICS.LOGIN_FALLBACK.MFA_SUCCESS_TITLE', {methodTypeTitle: methodType.methodTypeTitle}),
				bodyText: bodyText
			};
		}
	});
});